import React from 'react';
import { connect } from "react-redux";
import "devextreme/ui/lookup";
import 'devextreme-react/date-range-box';
import * as actionsDuck from '../../../store/ducks/actions.duck';
import { Stepper, Item as StepperItem } from 'devextreme-react/stepper';
import { MultiView } from 'devextreme-react/multi-view';
import validationEngine from 'devextreme/ui/validation_engine';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment';
import * as calendarCrud from "../../../crud/calendar.crud";
import { withSnackbar } from 'notistack';
import { Form, SimpleItem, RangeRule, RequiredRule, GroupItem } from 'devextreme-react/form';
import { LoadPanel } from 'devextreme-react/load-panel';
import { ReactComponent as SuccessIcon } from "../../../../_metronic/layout/assets/layout-svg-icons/Success.svg";
import ActionsCalendarSubscriptionState from "./ActionsCalendarSubscriptionState";
import { confirm } from 'devextreme/ui/dialog';
import { getCalendarSubscriptionCoverageOptions, getCalendarSubscriptionItemTypes, getCalendarSubscriptionReminders, getCalendarSubscriptionReminderTypes } from '../../../shared/lookup';



const validationGroups = ['dates', 'coverage', 'itemtype', 'reminder'];



const initialState = {
    steps: [],
    selectedIndex: 0,
    subscriptionURL: null,
    nextButtonText: 'Next',
    formData: {
        calendarsubscriptionid: 0,
        nodatefilter: true,
        dates: [moment().subtract(1, 'years')._d, moment().add(10, 'years')._d],
        coverage: null,
        itemtype: "EVENT",
        reminder: undefined,
        remindertype: undefined,
    },

}
class ActionsCalendarSubscriptionWizard extends React.Component {

    constructor(props) {
        super(props);
        this.loadPanelRef = React.createRef();
        this.coveragerOptions = getCalendarSubscriptionCoverageOptions(this.props.intl);
        this.coveragerOptionsObj = this.coveragerOptions.reduce((obj, item) => ({ ...obj, [item.value]: item.display }), {});

        this.itemTypes = getCalendarSubscriptionItemTypes(this.props.intl);
        this.itemTypesObj = this.itemTypes.reduce((obj, item) => ({ ...obj, [item.value]: item.display }), {});

        this.reminders = getCalendarSubscriptionReminders(this.props.intl);
        this.remindersObj = this.reminders.reduce((obj, item) => ({ ...obj, [item.value]: item.display }), {});

        this.reminderTypes = getCalendarSubscriptionReminderTypes(this.props.intl);
        this.reminderTypesObj = this.reminderTypes.reduce((obj, item) => ({ ...obj, [item.value]: item.display }), {});

        this.state = this.getInitialState();

    }
    getInitialState = () => {
        const newState = JSON.parse(JSON.stringify(initialState));
        newState.nextButtonText = this.props.intl.formatMessage({ id: 'GENERAL.BUTTON.NEXT' })
        newState.steps = [
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.DATES' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.DATES' }),
                icon: 'daterangepicker',
            },
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.COVERAGE' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.COVERAGE' }),
                icon: 'group',
            },
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.ITEM_TYPE' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.ITEM_TYPE' }),
                icon: 'tags',
            },
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.REMINDERS' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.REMINDERS' }),
                icon: 'bell',
                // optional: true,
            },
            {
                label: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.CONFIRMATION' }),
                hint: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.CONFIRMATION' }),
                icon: 'checkmarkcircle',
            },
        ];
        return newState;
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    fetchActiveSubscription = async () => {
        try {
            if (this.loadPanelRef.current) {
                this.loadPanelRef.current.instance().show();
            }

            const { data: result, config } = await calendarCrud.getActiveSubscription();
            let timerMS = 100;
            if (config && config.meta && config.meta.requestStartedAt) {
                let executionTimeMs = (new Date().getTime() - config.meta.requestStartedAt);
                if (executionTimeMs < 800) {
                    timerMS = 900 - executionTimeMs;
                }
            }

            if (result) {
                this.timer = setTimeout(() => {
                    this.setState({
                        selectedIndex: 4,
                        subscriptionURL: result.url,
                        formData: {
                            calendarsubscriptionid: result.calendarsubscriptionid,
                            nodatefilter: result.nodatefilter,
                            dates: [new Date(result.startdate), new Date(result.enddate)],
                            coverage: result.coverage,
                            itemtype: result.itemtype,
                            reminder: result.reminder,
                            remindertype: result.remindertype,
                        }
                    })
                    if (this.loadPanelRef.current) {
                        this.loadPanelRef.current.instance().hide();
                    }
                }, timerMS);
            }
            else {
                this.timer = setTimeout(() => {
                    if (this.loadPanelRef.current) {
                        this.loadPanelRef.current.instance().hide();
                    }
                }, timerMS);
            }
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            if (this.loadPanelRef.current) {
                this.loadPanelRef.current.instance().hide();
            }
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }


    }
    onSelectionChanged = ({ component }) => {
        console.log("onSelectionChanged")
        this.setState({ selectedIndex: (component.option('selectedIndex') ?? 0) });
    }
    onSelectionChanging = (args) => {
        if (!this.state.subscriptionURL) {
            const { component, addedItems, removedItems } = args;
            const { items = [] } = component.option();
            const addedIndex = items.findIndex((item) => item === addedItems[0]);
            const removedIndex = items.findIndex((item) => item === removedItems[0]);
            const isMoveForward = addedIndex > removedIndex;
            if (isMoveForward) {
                const isValid = this.getValidationResult(removedIndex);
                this.setStepValidationResult(removedIndex, isValid);
                if (isValid === false) {
                    args.cancel = true;
                }
            }
        }


    }
    getValidationResult = (index) => {
        if (index >= validationGroups.length) {
            return true;
        }
        return validationEngine.validateGroup(validationGroups[index]).isValid;
    }
    setStepValidationResult = (index, isValid) => {
        const newSteps = [...this.state.steps];
        newSteps[index] = { ...newSteps[index], isValid };
        this.setState({ steps: newSteps });
    }
    getInitialButtonText = (index) => {
        if (index === this.state.steps.length - 1) {
            if (this.state.formData.calendarsubscriptionid) {
                return this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.BUTTON.CHANGE' });
            }
            else {
                return this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.BUTTON.GENERTE' });
            }

        }
        return this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.BUTTON.NEXT' });
    }
    onPrevButtonClick = () => {
        const { selectedIndex } = this.state;
        const nextIndex = selectedIndex - 1;
        const nextButtonText = this.getInitialButtonText(nextIndex);
        this.setState({ selectedIndex: nextIndex, nextButtonText });
    }
    onChangeSettingsClick = () => {

        if (this.state.subscriptionURL) {
            const newState = this.getInitialState();;
            newState.formData.calendarsubscriptionid = this.state.formData.calendarsubscriptionid;
            this.setState(newState);
        }

    }
    onNextButtonClick = async () => {

        const { selectedIndex, steps, formData } = this.state;
        const currentValidationGroup = validationGroups[selectedIndex];
        const result = validationEngine.validateGroup(currentValidationGroup);

        if (result.isValid) {
            if (selectedIndex === steps.length - 1) {
                if (formData.calendarsubscriptionid) {
                    this.updateSubscriptionURL();
                }
                else {
                    this.generateSubscriptionURL();
                }

            }
            else {
                if (selectedIndex === 2 && formData.itemtype === 'TODO') {
                    //confirm TODO item type
                    const isTodoConfirmed = await this.confirmTodoEventType();
                    if (!isTodoConfirmed) {
                        //do not move forward
                        return;
                    }
                }
                const nextIndex = selectedIndex + 1;
                const nextButtonText = this.getInitialButtonText(nextIndex);
                // Move to Next Step
                this.setState({ selectedIndex: nextIndex, nextButtonText });
            }
        }


    }
    generateSubscriptionURL = async () => {
        try {
            this.loadPanelRef.current.instance().show();
            const { formData } = this.state;
            const payload = {
                nodatefilter: formData.nodatefilter,
                startdatedisplay: !formData.nodatefilter ? moment(formData.dates[0]).format('DD/MM/YYYY') : '',
                enddatedisplay: !formData.nodatefilter ? moment(formData.dates[1]).format('DD/MM/YYYY') : '',
                coverage: formData.coverage,
                itemtype: formData.itemtype,
                reminder: formData.reminder,
                reminderType: formData.remindertype,
            };
            const { data: newSubscription } = await calendarCrud.generateSubscriptionURL(payload);
            const newFormData = { ...formData };
            newFormData.calendarsubscriptionid = newSubscription.calendarsubscriptionid;
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.MESSAGE.CREATED' }), { variant: 'success' });
            this.setState({ subscriptionURL: newSubscription.url, formData: newFormData });
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
        finally {
            this.timer = setTimeout(() => {
                if (this.loadPanelRef.current) {
                    this.loadPanelRef.current.instance().hide();
                }
            }, 500);
        }


    }
    updateSubscriptionURL = async () => {
        try {
            this.loadPanelRef.current.instance().show();
            const { formData } = this.state;
            const payload = {
                calendarsubscriptionid: formData.calendarsubscriptionid,
                nodatefilter: formData.nodatefilter,
                startdatedisplay: !formData.nodatefilter ? moment(formData.dates[0]).format('DD/MM/YYYY') : '',
                enddatedisplay: !formData.nodatefilter ? moment(formData.dates[1]).format('DD/MM/YYYY') : '',
                coverage: formData.coverage,
                itemtype: formData.itemtype,
                reminder: formData.reminder,
                reminderType: formData.remindertype,
            };
            const { data: subscriptionURL } = await calendarCrud.updateSubscriptionURL(payload);
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.MESSAGE.UPDATE' }), { variant: 'success' });
            this.setState({ subscriptionURL });
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
        finally {
            this.timer = setTimeout(() => {
                if (this.loadPanelRef.current) {
                    this.loadPanelRef.current.instance().hide();
                }
            }, 500);
        }

    }
    confirmCancelSubscription = async () => {
        const warningMessage = this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.CANCELLATION.MESSAGE' });
        const warningMessageTitle = this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.CANCELLATION.TITLE' });
        let result = await confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageTitle}`);
        return result;
    }
    confirmTodoEventType = async () => {
        const warningMessage = this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.TODO_ITEM.MESSAGE' });
        const warningMessageTitle = this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.TODO_ITEM.TITLE' });
        let result = await confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageTitle}`);
        return result;
    }
    onCancelSubscription = async () => {
        try {
            const isCancellationConfirmed = await this.confirmCancelSubscription();
            if (isCancellationConfirmed) {
                this.loadPanelRef.current.instance().show();
                await calendarCrud.cancelSubscription();
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.MESSAGE.CANCEL' }), { variant: 'success' });
                const newState = this.getInitialState();
                this.setState(newState);
            }

        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
        finally {
            this.timer = setTimeout(() => {
                if (this.loadPanelRef.current) {
                    this.loadPanelRef.current.instance().hide();
                }
            }, 500);
        }

    }
    onClose = () => {
        if (this.props.visible) {
            const newState = this.getInitialState();
            this.setState(newState, () => {
                this.props.onDialogResult();
            });
        }
    }
    onPopupShowing = () => {

        this.fetchActiveSubscription();
    }
    render() {
        const { steps, selectedIndex, formData, nextButtonText, subscriptionURL } = this.state;
        return (
            <Popup
                visible={this.props.visible}
                onHiding={this.onClose}
                dragEnabled={true}
                hideOnOutsideClick={false}
                showTitle={true}
                title={this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.TITLE' })}
                width={800}
                minHeight={700}
                // onContentReady={this.onPopupContentReady}
                onShowing={this.onPopupShowing}
                height='auto'>
                <LoadPanel
                    ref={this.loadPanelRef}
                    // onContentReady={this.onLoadPanelContentReady}
                    shadingColor="rgba(0,0,0,0.4)"
                    // message='Fetching Calendar Subscription Info'
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                    // delay={300}
                    position={{ of: '#popupContainer' }}
                />

                <>
                    <div id="ActionsCalendarSubscriptionWizard">
                        <Stepper
                            className={!!subscriptionURL ? 'readonly' : ''}
                            focusStateEnabled={!subscriptionURL}
                            selectedIndex={selectedIndex}
                            onSelectionChanged={this.onSelectionChanged}
                            onSelectionChanging={this.onSelectionChanging}
                            visible={(!this.state.subscriptionURL)}
                        >
                            {steps.map((step) => (
                                <StepperItem
                                    key={step.label}
                                    {...step}
                                />
                            ))}
                        </Stepper>
                        <ActionsCalendarSubscriptionState url={subscriptionURL} status={1} />
                        <div className="content">
                            <MultiView
                                selectedIndex={selectedIndex}
                                focusStateEnabled={false}
                                animationEnabled={false}
                                swipeEnabled={false}
                                height={400}
                            >
                                <StepperItem >
                                    <React.Fragment>
                                        <p>
                                            <FormattedMessage id='CALENDAR_SUBSCRIPTION.STEP.DATES' />
                                        </p>
                                        <Form
                                            formData={formData}
                                            validationGroup="dates"
                                            style={{ margin: 30 }}
                                            onFieldDataChanged={(e) => {
                                                if (e.dataField === 'nodatefilter')
                                                    this.setState({
                                                        formData: {
                                                            ...this.state.formData,
                                                            [e.dataField]: e.value
                                                        }
                                                    });
                                            }}
                                        >
                                            <SimpleItem
                                                dataField="nodatefilter"
                                                editorType="dxCheckBox"
                                                label={{ visible: false }}
                                                editorOptions={{
                                                    text: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.NO_DATE_FILTERS' }),
                                                }}
                                            // label={{ location: "right", text: "No date", alignment: "right" }}
                                            />

                                            <SimpleItem
                                                isRequired
                                                dataField="dates"
                                                editorType="dxDateRangeBox"
                                                disabled={!!formData.nodatefilter}
                                                // visible={!formData.nodatefilter}
                                                editorOptions={{
                                                    min: moment().subtract(10, 'years')._d,
                                                    max: moment().add(10, 'years')._d,
                                                    startDatePlaceholder: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.START_DATE_FORMATTED' }),
                                                    endDatePlaceholder: this.props.intl.formatMessage({ id: 'CALENDAR_SUBSCRIPTION.LABEL.END_DATE_FORMATTED' }),
                                                    displayFormat: 'dd/MM/yyyy',
                                                    acceptCustomValue: true,
                                                    useMaskBehavior: true,
                                                    // readOnly : !!formData.nodatefilter,
                                                    // elementAttr: { id: 'datesPicker' },
                                                    calendarOptions: {
                                                        firstDayOfWeek: 1,
                                                        min: moment().subtract(10, 'years')._d,
                                                        max: moment().add(10, 'years')._d,
                                                    }
                                                }}
                                                // label={{ text: "Enter range" }}
                                                label={{ visible: false }}
                                            />
                                        </Form>
                                    </React.Fragment>
                                </StepperItem>
                                <StepperItem>
                                    <React.Fragment>
                                        <p>
                                            <FormattedMessage id='CALENDAR_SUBSCRIPTION.STEP.COVERAGE' />
                                        </p>

                                        <Form
                                            formData={formData}
                                            validationGroup="coverage"
                                            style={{ margin: 30 }}
                                        >
                                            <SimpleItem
                                                // colCount={5}
                                                isRequired={true}
                                                dataField="coverage"
                                                editorType="dxRadioGroup"
                                                editorOptions={{
                                                    layout: "horizontal",
                                                    dataSource: this.coveragerOptions,
                                                    displayExpr: 'display',
                                                    valueExpr: 'value',
                                                }}

                                                label={{ visible: false }}
                                            >
                                                {/* <RequiredRule message={"Required"} /> */}
                                            </SimpleItem>
                                        </Form>
                                    </React.Fragment>
                                </StepperItem>
                                <StepperItem  >
                                    <React.Fragment>
                                        <p>
                                            <FormattedMessage id='CALENDAR_SUBSCRIPTION.STEP.ITEM_TYPE' />
                                        </p>

                                        <Form
                                            formData={formData}
                                            validationGroup="itemtype"
                                            style={{ margin: 30 }}
                                        >
                                            <SimpleItem
                                                isRequired={true}
                                                dataField="itemtype"
                                                editorType="dxRadioGroup"
                                                editorOptions={{
                                                    layout: "horizontal",
                                                    dataSource: this.itemTypes,
                                                    displayExpr: 'display',
                                                    valueExpr: 'value',
                                                }}

                                                label={{ visible: false }}
                                            >
                                                {/* <RequiredRule message={"Required"} /> */}
                                            </SimpleItem>
                                        </Form>
                                    </React.Fragment>
                                </StepperItem>
                                <StepperItem >
                                    <React.Fragment>
                                        <p>
                                            <FormattedMessage id='CALENDAR_SUBSCRIPTION.STEP.REMINDERS' />
                                        </p>
                                        <Form
                                            formData={formData}
                                            style={{ margin: 30 }}
                                            onFieldDataChanged={(e) => {
                                                if (e.dataField === 'reminder')
                                                    this.setState({
                                                        formData: {
                                                            ...this.state.formData,
                                                            [e.dataField]: e.value
                                                        }
                                                    });
                                            }}
                                            validationGroup="reminder"
                                        >
                                            <SimpleItem itemType="empty" />
                                            <SimpleItem
                                                isRequired={true}
                                                dataField="reminder"
                                                editorType="dxRadioGroup"
                                                editorOptions={{
                                                    layout: "horizontal",
                                                    dataSource: this.reminders,
                                                    displayExpr: 'display',
                                                    valueExpr: 'value',
                                                }}

                                                label={{ visible: false }}
                                            >
                                                {/* <RequiredRule message={"Required"} /> */}
                                            </SimpleItem>
                                            <SimpleItem itemType="empty" />
                                            <SimpleItem
                                                visible={(!!formData.reminder && formData.reminder !== 'NONE')}
                                                isRequired={true}
                                                dataField="remindertype"
                                                editorType="dxRadioGroup"
                                                editorOptions={{
                                                    layout: "horizontal",
                                                    dataSource: this.reminderTypes,
                                                    displayExpr: 'display',
                                                    valueExpr: 'value',
                                                }}

                                                label={{ visible: false }}
                                            >
                                                {/* <RequiredRule message={"Required"} /> */}
                                            </SimpleItem>
                                        </Form>
                                    </React.Fragment>
                                </StepperItem>
                                <StepperItem >
                                    <div className="summary-container">
                                        <div className="summary-item">
                                            <div className="summary-item-header"> <FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.DATES' /></div>
                                            <div className="separator"></div>
                                            {
                                                formData.nodatefilter ? (
                                                    <div>
                                                        <FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.NO_DATE_FILTERS' />
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div>
                                                            <span className="summary-item-label"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.START_DATE' />: </span>
                                                            {moment(formData.dates[0]).format('DD/MM/YYYY')}
                                                        </div>
                                                        <div>
                                                            <span className="summary-item-label"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.END_DATE' />: </span>
                                                            {moment(formData.dates[1]).format('DD/MM/YYYY')}
                                                        </div>
                                                    </>
                                                )

                                            }

                                        </div>

                                        <div className="summary-item">
                                            <div className="summary-item-header"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.COVERAGE' /></div>
                                            <div className="separator"></div>
                                            <div>
                                                {this.coveragerOptionsObj[formData.coverage]}
                                            </div>
                                        </div>

                                        <div className="summary-item">
                                            <div className="summary-item-header"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.ITEM_TYPE' /></div>
                                            <div className="separator"></div>
                                            <div>
                                                {this.itemTypesObj[formData.itemtype]}
                                            </div>
                                        </div>

                                        <div className="summary-item">
                                            <div className="summary-item-header"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.REMINDERS' /></div>
                                            <div className="separator"></div>
                                            <div>
                                                <span className="summary-item-label"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.REMINDER' />: </span>
                                                {this.remindersObj[formData.reminder]}
                                            </div>
                                            {
                                                formData.reminder !== 'NONE' && (
                                                    <div>
                                                        <span className="summary-item-label"><FormattedMessage id='CALENDAR_SUBSCRIPTION.LABEL.REMINDER_TYPE' />: </span>
                                                        {this.reminderTypesObj[formData.remindertype]}
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>
                                </StepperItem>
                            </MultiView>

                        </div>
                    </div>
                    <div style={{ position: "fixed", bottom: 30, left: 20 }} className="current-step">
                        {!subscriptionURL && (
                            <React.Fragment>
                                Step <span className="selected-index">{selectedIndex + 1}</span>
                                {' of '}
                                {steps.length}
                            </React.Fragment>
                        )}
                    </div>
                </>

                <ToolbarItem
                    visible={selectedIndex !== 0 && !subscriptionURL}
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{ text:this.props.intl.formatMessage({ id: 'GENERAL.BUTTON.BACK' }), onClick: this.onPrevButtonClick }} />

                <ToolbarItem
                    visible={!subscriptionURL}
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        type: "default",
                        stylingMode: "contained",
                        text: nextButtonText,
                        // icon: '',
                        onClick: this.onNextButtonClick
                    }} />
                <ToolbarItem
                    visible={!!subscriptionURL}
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        type: "danger",
                        stylingMode: "outlined",
                        text: this.props.intl.formatMessage({ id: 'EMAIL_SUBSCRIPTION.BUTTON.CANCEL_SUBSCRIPTION' }),
                        onClick: this.onCancelSubscription
                    }} />
                <ToolbarItem
                    visible={!!subscriptionURL}
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        type: "default",
                        stylingMode: "contained",
                        text: this.props.intl.formatMessage({ id: 'EMAIL_SUBSCRIPTION.BUTTON.CHANGE_SETTINGS' }),
                        // icon: '',
                        onClick: this.onChangeSettingsClick
                    }} />

            </Popup >

        );
    }
}


export default withSnackbar(injectIntl(ActionsCalendarSubscriptionWizard));